import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const LabelSettingRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--label-settings']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
